import { AfterViewInit, Component, TemplateRef, inject } from '@angular/core';
import { Concepto, CFDI, FiguraTransporte, Ubicaciones, Mercancias, Impuestos2, totalesEncabezado, CartaPorte, RegimenAduaneroCCP, ImpuestosLocales } from '../../../../shared/models/factura-global.interface';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import JSZip from 'jszip';
import { SharedService } from '../../../../shared/services/shared.service';
import { forkJoin } from 'rxjs';
import { FacturacionService } from '../../../../shared/services/facturacion.service';
import { Select2Option } from 'ng-select2-component';
import { Cabecera, EmisoresForm, dataUser, } from '../../../../shared/models';
import { Receptor } from '../../../../shared/models/factura-global.interface';

@Component({
  selector: 'app-crear-factura-manual',
  standalone: false,
  templateUrl: './crear-factura-manual.component.html',
  styleUrl: './crear-factura-manual.component.scss'
})
export class CrearFacturaManualComponent implements AfterViewInit {
  public generalCFDI: CFDI;
  public data_emisor!: EmisoresForm;
  public data_receptor!: Receptor;
  public data_cabecera!: Cabecera;
  public data_ubicaciones!: Ubicaciones;
  public data_regimenAduaneros!: RegimenAduaneroCCP;
  public data_figuratransporte!: FiguraTransporte;
  public dataUser: dataUser;
  public dataUserStorage: any = sessionStorage.getItem("dataUser");
  public data_mercancias!: Mercancias;
  public data_concepto!: Concepto[];
  public data_impuestos2!: Impuestos2;
  public data_impuestos_locales!: ImpuestosLocales;
  public data_totales_encabezado!: totalesEncabezado;
  public data_totalDistRec!: number;
  private modalService = inject(NgbModal);
  public closeResult: string = '';
  public xml: string = '';
  public nombre: string = '';
  public pdfBase64: string = '';
  public isValidFormEncabezadoCartaporte: boolean = false;
  public isValidFormCabecera: boolean = false;
  public isValidFormEmisor: boolean = false;
  public isValidFormReceptor: boolean = false;
  public isValidFormMercancias: boolean = false;
  public isValidFormDetallista: boolean = false;
  public isFacturando: boolean = false;
  readonly ignoredTaxes = ["001", "002", "003"];
  public isLoadingCatalogos: boolean = false;

  public customListCatPais: Select2Option[] = [];
  public customUsoCfdi: Select2Option[] = [];
  public customListRegimen: Select2Option[] = [];
  public customListCatalogoMonedas: Select2Option[] = [];
  public customListCatFormaPago: Select2Option[] = [];
  public customListCatMetodoPago: Select2Option[] = [];
  public customListCatMoneda: Select2Option[] = [];

  constructor(
    private sharedService: SharedService,
    private facturacionService: FacturacionService
  ) {
    this.dataUser = JSON.parse(this.dataUserStorage);
    this.generalCFDI = {
      cfdiDto: {
        integracion: null,
        claveUnidad: null,
        referencia: null,
        serie: null,
        folio: null,
        folioInt: null,
        fecha: null,
        exportacion: null,
        formaPago: null,
        condicionesDePago: null,
        granTotal: null,
        total: null,
        subTotal: null,
        descuento: null,
        notas: null,
        moneda: null,
        tipoCambio: null,
        lugarExpedicion: null,
        confirmacion: null,
        tipoCfdi: null,
        metodoPago: null,
        cargosNoFacturables: [],
        cfdiRelacionados: [],
        emisor: {
          rfc: null,
          codigoPostal: null,
          facAtrAdquirente: null,
          nombre: null,
          regimenFiscal: null,
        },
        receptor: {
          calle: null,
          colonia: null,
          direccionEntrega: {
            calle: null,
            codigoPostal: null,
            colonia: null,
            estado: null,
            municipio: null,
            noExterior: null,
            noInterior: null,
            pais: null,
          },
          domicilioFiscal: null,
          email: null,
          estado: null,
          identificador: null,
          municipio: null,
          noExterior: null,
          noInterior: null,
          nombre: null,
          numRegIdTrib: null,
          pais: null,
          regimenFiscal: null,
          residenciaFiscal: null,
          rfc: null,
          usoCFDI: null,
        },
        conceptos: [],
        hospedaje: [],
        alimentos: [],
        impuestosLocales: {
          totalImpuestosRetenidos: null,
          totalImpuestosTrasladados: null,
          retencionesLocales: [],
          trasladoLocales: [],
        },
        informacionFacto: {
          identificadorIntegracion: null,
          integracion: null,
          foliosFacto: null,
          centroConsumoId: null,
          centroConsumoIdentificador: null,
          cxc: null,
          facturaAutomatica: null,
          tipoCfdi: null
        },
        addendas: null
      },
      identificadorSucursalId: null,
      centroConsumo: null,
      claveProducto: this.dataUser.clave_facto,
      idioma: null,
      ambiente: null,
      listAdicionalPDF: [],
      formato: null,
      listTicketsFacturar: [],
      id_transaccion: null
    };

    this.isLoadingCatalogos = true;

    forkJoin([
      this.facturacionService.usoPais(),
      this.facturacionService.usoCfdi(),
      this.facturacionService.regimenFiscal(),
      this.facturacionService.catalogoFormaPago(),
      this.facturacionService.catalogoMetodoPago(),
      this.facturacionService.catalogoMoneda(),
    ]).subscribe(([
      responseUsoPais,
      responseUsoCfdi,
      responseRegimenFiscal,
      responseFormaPago,
      responseMetodoPago,
      responseMoneda
    ]) => {

      //------------- Cat Lista Paises------------------------>
      this.customListCatPais = responseUsoPais.map(item => ({
        label: item.cPais + " - " + item.descripcion,
        value: item.cPais
      }));
      sessionStorage.setItem("CatalogPais", JSON.stringify(this.customListCatPais));
      //------------- Fin Cat Lista Paises------------------------>


      //------------- Cat Lista Uso CFDI ------------------------>
      this.customUsoCfdi = responseUsoCfdi.map(item => ({
        label: item.c_UsoCFDI + ' - ' + item.Descripcion,
        value: item.c_UsoCFDI
      }));
      sessionStorage.setItem("CatalogUSOCFDI", JSON.stringify(this.customUsoCfdi));
      //------------- Fin Cat Lista Uso CFDI ------------------------>


      //------------- Cat Lista Regimen fiscal ------------------------>
      this.customListRegimen = responseRegimenFiscal.map(item => ({
        label: item.c_RegimenFiscal + ' - ' + item.Descripcion,
        value: item.c_RegimenFiscal
      }));
      sessionStorage.setItem("regimenFiscal", JSON.stringify(this.customListRegimen));
      //------------- Fin Cat Lista Regimen fiscal ------------------------>


      //------------- Cat Lista Forma Pago ------------------------>
      this.customListCatFormaPago = responseFormaPago.map(item => ({
        label: item.cFormaPago + ' - ' + item.descripcion,
        value: item.cFormaPago
      }));
      sessionStorage.setItem("catFormaPago", JSON.stringify(this.customListCatFormaPago));
      //------------- Fin Cat Lista Forma Pago ------------------------>


      //------------- Cat Lista Método Pago ------------------------>
      this.customListCatMetodoPago = responseMetodoPago.map(item => ({
        label: item.cMetodoPago + ' - ' + item.descripcion,
        value: item.cMetodoPago
      }));
      sessionStorage.setItem("catMetodoPago", JSON.stringify(this.customListCatMetodoPago));
      //------------- Fin Cat Lista Método Pago ------------------------>


      //------------- Cat Lista Monedas ------------------------>
      this.customListCatalogoMonedas = responseMoneda.map(item => ({
        label: item.cMoneda + ' - ' + item.descripcion,
        value: item.cMoneda
      }));
      sessionStorage.setItem('CatMoneda', JSON.stringify(this.customListCatalogoMonedas));
      //------------- Fin Cat Lista Monedas ------------------------>


      //------------- Cat Lista Tipo Factor ------------------------>
      const datos = [
        {
          "value": "Tasa",
        },
        {
          "value": "Cuota",
        },
        {
          "value": "Exento",
        }
      ];

      const datosJSON = JSON.stringify(datos);
      sessionStorage.setItem('CatTipoFactor', datosJSON);
      //------------- Fin Cat Lista Tipo Factor ------------------------>
      this.isLoadingCatalogos = false;
    });
  }
  ngAfterViewInit(): void {
    this.isFacturando = true;
    setTimeout(() => {
      this.isFacturando = false;
    }, 2000);
  }

  public giveDataCabecera(data: Cabecera): void {
    this.data_cabecera = data;
    if (this.generalCFDI.cfdiDto.emisor !== null && this.generalCFDI.cfdiDto.emisor !== undefined) {
      this.generalCFDI.cfdiDto.tipoCfdi = this.data_cabecera.tipoCfdi;
      this.generalCFDI.cfdiDto.exportacion = this.data_cabecera.exportacion;
      this.generalCFDI.cfdiDto.referencia = this.data_cabecera.referencia;
      this.generalCFDI.cfdiDto.fecha = this.data_cabecera.fecha;
      this.generalCFDI.cfdiDto.formaPago = this.data_cabecera.formaPago;
      this.generalCFDI.cfdiDto.condicionesDePago = this.data_cabecera.condicionesDePago;
      this.generalCFDI.cfdiDto.metodoPago = this.data_cabecera.metodoPago;
      this.generalCFDI.cfdiDto.moneda = this.data_cabecera.moneda;
      this.generalCFDI.idioma = this.data_cabecera.idioma;
    }
  }

  public giveFormValidationCabecera(event: boolean): void {
    this.isValidFormCabecera = event;
  }

  public giveDataEmisor(data: EmisoresForm): void {
    this.data_emisor = data;
    if (this.generalCFDI.cfdiDto.emisor !== null && this.generalCFDI.cfdiDto.emisor !== undefined) {
      this.generalCFDI.cfdiDto.emisor.rfc = this.data_emisor.rfc;
      this.generalCFDI.cfdiDto.emisor.codigoPostal = this.data_emisor.codigoPostal;
      this.generalCFDI.cfdiDto.emisor.nombre = this.data_emisor.nombre;
      this.generalCFDI.cfdiDto.emisor.regimenFiscal = this.data_emisor.regimenFiscal;
      this.generalCFDI.cfdiDto.emisor.facAtrAdquirente = this.data_emisor.facAtrAdquirente;
      this.generalCFDI.identificadorSucursalId = this.data_emisor.centroConsumoId;
      this.generalCFDI.cfdiDto.serie = this.data_emisor.serie;
    }
  }
  
  public giveFormValidationEmisor(event: boolean): void {
    this.isValidFormEmisor = event;
  }

  public giveDataReceptor(data: Receptor): void {
    this.data_receptor = data;
    if (this.generalCFDI.cfdiDto.receptor !== null && this.generalCFDI.cfdiDto.receptor !== undefined) {
      this.generalCFDI.cfdiDto.receptor = this.data_receptor;
    }
  }

  public giveFormValidationReceptor(event: boolean): void {
    this.isValidFormReceptor = event;
  }


  public giveDataConcepto(data: Concepto[]): void {
    this.data_concepto = data;
    this.generalCFDI.cfdiDto.conceptos = this.data_concepto;


  }

  public giveDataTotalEncabezado(data: totalesEncabezado): void {
    this.data_totales_encabezado = data;
    this.generalCFDI.cfdiDto.total = parseFloat(this.data_totales_encabezado.total).toFixed(2);
    this.generalCFDI.cfdiDto.subTotal = this.data_totales_encabezado.subTotal;
  }

  public giveDataImpuestos(data: Impuestos2): void {

    data.retenciones = data.retenciones.filter(impuesto =>
      this.ignoredTaxes.includes(impuesto.impuesto.toString())
    )
    this.data_impuestos2 = data;
    this.generalCFDI.cfdiDto.impuestos = this.data_impuestos2;
  }

  public giveDataImpuestosLocales(data: ImpuestosLocales): void {

    data.retencionesLocales = data.retencionesLocales.filter(impuesto =>
      !this.ignoredTaxes.includes(impuesto.impuesto.toString())
    )
    this.data_impuestos_locales = data;
    this.generalCFDI.cfdiDto.impuestosLocales = this.data_impuestos_locales;
  }

  public open(content: TemplateRef<any>) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then(
      (result) => {
        this.closeResult = `Closed with: ${content}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      },
    );
  }


  public openScrollableContent(longContent: TemplateRef<any>) {
    this.modalService.open(longContent, { scrollable: true, centered: true, backdrop: 'static' });
  }



  cerrarModal() {
    window.location.reload();
  }

  base64toXML(base64String: string): string {
    const decodedString = atob(base64String);
    return decodedString;
  }

  descargarZIP(): void {
    const zip = new JSZip();

    // Agregar el XML al archivo ZIP
    zip.file(this.nombre + '.xml', this.xml);

    // Convertir el PDF de base64 a Blob y agregarlo al archivo ZIP
    const pdfBlob = this.base64toBlob(this.pdfBase64, 'application/pdf');
    zip.file(this.nombre + '.pdf', pdfBlob);

    // Generar el archivo ZIP
    zip.generateAsync({ type: 'blob' }).then((content) => {
      // Descargar el archivo ZIP utilizando la API de descarga nativa de JavaScript
      const link = document.createElement('a');
      link.href = URL.createObjectURL(content);
      link.download = this.nombre + '.zip';
      link.click();
    });
  }

  base64toBlob(base64String: string, contentType: string): Blob {
    const byteCharacters = atob(base64String);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
  }



  private getDismissReason(reason: any): string {
    switch (reason) {
      case ModalDismissReasons.ESC:
        return 'by pressing ESC';
      case ModalDismissReasons.BACKDROP_CLICK:
        return 'by clicking on a backdrop';
      default:
        return `with: ${reason}`;
    }
  }





  public generarCFDI(longContent: TemplateRef<any>): void {


    if (!this.isValidFormCabecera) {
      // this.openScrollableContent(longContent);
      this.sharedService.eventCreateToaster.emit({
        header: '¡Error!',
        message: 'Por favor, completa el formulario de Cabecera',
        type: 'error'
      });
      return; // Detener la ejecución del método si el formulario de Cabecera no es válido


    }

    // Validar el formulario de Receptor
    if (!this.isValidFormReceptor) {
      this.sharedService.eventCreateToaster.emit({
        header: '¡Error!',
        message: 'Por favor, completa el formulario de Receptor',
        type: 'error'
      });
      return; // Detener la ejecución del método si el formulario de Receptor no es válido
    }

    if (!this.isValidFormEmisor) {
      this.sharedService.eventCreateToaster.emit({
        header: '¡Error!',
        message: 'Por favor, completa el formulario de Emisor',
        type: 'error'
      });
      return; // Detener la ejecución del método si el formulario de Receptor no es válido
    }




    if (this.isValidFormCabecera && this.isValidFormEmisor && this.isValidFormReceptor) {
      this.isFacturando = true;
      console.log(this.generalCFDI);
      
      // this.facturacionService.facturar(this.generalCFDI).subscribe(
      //   response => {
      //     // console.log(response);
      //     this.xml = this.base64toXML(response.xml);
      //     this.nombre = response.nombre_archivo
      //     this.pdfBase64 = response.pdf;
      //     this.sharedService.eventCreateToaster.emit({ header: '¡Éxito!', message: 'Se ha generado tu factura correctamente.', type: 'success' });
      //     this.openScrollableContent(longContent);


      //     // setTimeout(() => {
      //     //   window.location.reload();
      //     // }, 4000);
      //   }, (error: any) => {
      //     this.isFacturando = false;
      //     if (error.error && error.error.detail) {
      //       this.sharedService.eventCreateToaster.emit({ header: '¡Error!', message: error.error.detail, type: 'error', delay: 20000 });
      //     } else {
      //       this.sharedService.eventCreateToaster.emit({ header: '¡Error!', message: 'Ocurrió un error desconocido.', type: 'error', delay: 20000 });
      //     }
      //   }

      // );
      // Puedes agregar aquí más acciones que desees realizar después del éxito, como abrir contenido adicional
    }
  }
}